import React from 'react'

const noop = () => Promise.reject(new Error('Not available'))

const initialState = {
  init: noop,
  closeConnection: noop,
  standByUntilUserReturn: noop,
  openAppLink: noop,
  initialising: false,
  resuming: false,
  active: false,
  sharingStatus: '',
  qrCodeUrl: '',
  qrCodeAppLinkUrl: '',
  error: null,
  details: {
    organisation: null,
    application: null,
    attributes: null,
    identityProfile: null,
    advancedIdentityProfile: null
  }
}

const ShareFlowContext = React.createContext(initialState)

export default ShareFlowContext
